module.exports = "https://img.xiyuyouxi.com/saas/img/Payment_icon0.172da5af.png";